// StatsSection.jsx
import React from 'react';
import { Building, Map, ShieldCheck, Layers } from 'lucide-react';
import './StatsSection.css';

export default function StatsSection() {
const stats = [
  {
    icon: <Building size={40} className="stat-icon" />,
    number: "250+",
    label: "Projects Delivered"
  },
  {
    icon: <Map size={40} className="stat-icon" />,
    number: "40+",
    label: "Locations Covered"
  },
  {
    icon: <ShieldCheck size={40} className="stat-icon" />,
    number: "100%",
    label: "Client Satisfaction"
  },
  {
    icon: <Layers size={40} className="stat-icon" />,
    number: "12",
    label: "Service Categories"
  }
];

  return (
    <div className="stats-section">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div className="stat-card" key={index}>
              {stat.icon}
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}